import { useEffect, useState } from 'react'
import useAppContext from '@/hooks/useAppContext'
import useModal from '@/hooks/useModal'
import ModalCustom from '@/scenes/Editor/components/Modal/Modal'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { useAppDispatch } from '@/store/store'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { setCallbackFromCreationPage } from '@/store/slices/editor/action'
import { setUploads } from '@/store/slices/uploads/actions'
import { customAmplitude } from '@/utils/customAmplitude'
import { selectTemplateConfig } from '@/store/slices/templates/selectors'
import { useSelector } from 'react-redux'
import NetworkStatusService from '@/shared/services/NetworkStatusService'

function ModalDicardProject() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { setisOpenPixelManipulationObject, setToolType } = useAppContext()
  const { showModalType, setShowModalType } = useModal()
  const templateConfig = useSelector(selectTemplateConfig)

  const [hasConnection, setHasConnection] = useState(() => NetworkStatusService.getInstance().getStatus())

  useEffect(() => {
    const service = NetworkStatusService.getInstance()
    const handleChange = (online: boolean) => setHasConnection(online)
    service.addListener(handleChange)
    return () => { service.removeListener(handleChange) }
  }, [])
  
  const close = () => {
    dispatch(setUploads([]))
    setShowModalType(null)
    dispatch(setCallbackFromCreationPage(null))
    setisOpenPixelManipulationObject(false)
    setToolType(null)
    customAmplitude('Open', { Source: 'Editor' })
  }
  
  if(hasConnection) {
    return (
      <ModalCustom
        isOpen={showModalType === ShowModalType.DISCARD_PROJECT}
        onClose={() => setShowModalType(null)}
        content={{
          header: t('Save project?'),
          desc: t("You're leaving this page and your project will not be saved. Sign in to save it for future use.")
        }}
        action={{
          primary: {
            name: t('Sign in & save'),
            handle: async () => {
              setShowModalType(null)
              close()
              setShowModalType(ShowModalType.SIGN_IN)
            },
          },
          secondary: {
            name: t('Discard and leave'),
            handle: () => {
              setShowModalType(null)
              close()
              if(hasConnection){
                dispatch(setUploads([]))            
                customAmplitude('Open', { Source: 'Editor' })
              }
              let isProject = templateConfig?.draftGuid && !templateConfig?.templateId
              if(isProject) {
                history.push('/create/projects')
              } else {
                history.push('/create')
              }
            },
          },
        }}
      />
    )
  }
  return (
    <ModalCustom
      isOpen={showModalType === ShowModalType.DISCARD_PROJECT}
      onClose={() => setShowModalType(null)}
      content={{
        header: t("Looks like there's no internet"),
        desc: t('You\'re leaving this page and your project will not be saved.')
      }}
      action={{
        primary: {
          name: t('Discard'),
          handle: async () => {
            setShowModalType(null)
            close()
            let isProject = templateConfig?.draftGuid && !templateConfig?.templateId
            if(isProject) {
              history.push('/create/projects')
            } else {
              history.push('/create')
            }
          },
        },
        secondary: {
          name: t('Cancel'),
          handle: () => {
            setShowModalType(null)
            close()
          },
        },
      }}
    />
  )
}

export default ModalDicardProject